import { Loader } from "@nimble/react-requests/components/shared/loader";
import { ClipboardList, Sparkles, UserRound } from "lucide-react";

import SignInButtonWrapper from "@/app/(discover)/components/sign-in-button-wrapper";
import { cn } from "@/lib/utils";

interface Benefit {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const BENEFITS: Benefit[] = [
  {
    icon: <UserRound className="h-4 w-4" aria-hidden="true" />,
    title: "Build your profile",
    description: "Add your experience and what you're looking for.",
  },
  {
    icon: <Sparkles className="h-4 w-4" aria-hidden="true" />,
    title: "Get matched",
    description: "Principals reach out with roles that fit you.",
  },
  {
    icon: <ClipboardList className="h-4 w-4" aria-hidden="true" />,
    title: "Track applications",
    description: "Follow every role you apply to in one place.",
  },
];

export default function AuthPaywall({
  isLoading,
  className,
  testId,
}: {
  isLoading?: boolean;
  className?: string;
  testId?: string;
}) {
  if (isLoading) {
    return (
      <div className="mx-auto max-w-md mt-6">
        <div className="flex justify-center">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md mt-6">
      <div
        className={cn(
          "rounded-2xl bg-card px-5 py-6 sm:px-6 shadow-card",
          className,
        )}
      >
        <div>
          <h2 className="text-xl sm:text-[22px] font-bold text-foreground leading-tight">
            Sign in to keep exploring
          </h2>
          <p className="mt-1.5 text-sm text-ink-subtle leading-relaxed">
            Saved schools, applications, and principal matches all stay with
            your account.
          </p>
        </div>

        <ul className="mt-5 space-y-3.5">
          {BENEFITS.map((benefit) => (
            <li key={benefit.title} className="flex items-start gap-3">
              <span className="flex-shrink-0 mt-0.5 text-primary">
                {benefit.icon}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground leading-snug">
                  {benefit.title}
                </h3>
                <p className="text-xs text-ink-subtle leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </li>
          ))}
        </ul>

        <div className="mt-6">
          <SignInButtonWrapper
            variant="default"
            className="w-full h-11 pointer-events-auto"
            testId={testId}
          />
        </div>
      </div>
    </div>
  );
}
